import { ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';

export const schema: ProfessionalExperienceEntryType = {
	showMeOn: ['all'],
	length: '~2 years',
	timespan: '2018 - 2020',
	title: 'Staff Software Engineer / Senior Software Engineer',
	languages: ['Typescript', 'Javascript', 'Assembly', 'Kotlin', 'C++', 'Python'],
	technologies: [
		'Angular',
		'ReactJS',
		'React Native',
		'NodeJS (Express)',
		'SQL (OLTP / OLAP)',
		'NoSQL',
		'Redis',
		/*'Handlebars'*/
	],
	tools: ['AWS', 'GCP'],
	company: 'Chowbotics',
	description: 'A company that manufactured and sold food robots',
	location: 'Hayward, California',
	employeeNumber: {
		type: 'approximate',
		number: 25,
	},
	results: 'Oct 2020 - Acquired by {DoorDash, https://about.doordash.com/en-ca/company}',

	details: [
		{
			showMeOn: ['all'],
			entry: 'Enabled real-time telemetry from 200+ connected robots by migrating to distributed architecture for processing device data',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Led post-migration efforts of a 7-engineer team focused on telemetry, iterative feature delivery, and continuous system evolution',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Scaled support capacity from 10 to 150+ robots of a 3-person Customer Success team by introducing a notification service that optimized field-to-operations information flow, subverting the need to increase staffing',
		},
		{
			showMeOn: ['all'],
			entry: 'Boosted kiosk uptime from 40% to 95% by implementing failover and automatic recovery from mechanical failure modes',
		},
		{
			showMeOn: ['all'],
			entry: 'Increased deployment success by 25% by launching a real-time monitoring portal that helped partners track robot health',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Improved meal satisfaction by 50% by surfacing local ingredient preferences and partnering with Culinary to optimize offerings',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Boosted campaign participation by 30% by equipping Marketing with behavioral insights to shape targeting strategies',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Reduced time-to-meal by 20% by implementing crowd-sourced suggestion engine to assist in building delicious meals',
		},
		{
			autonomous: true,
			showMeOn: ['all'],
			entry: 'Resolved 50+ latent UX friction points by observing user behavior — hesitation, expressions, body language — often missed in conventional testing',
		},
		{
			showMeOn: ['all'],
			entry: 'Reduced my personal frustration over internal misunderstandings by ∞% by establishing & enforcing common terminology',
		},
	],
};
